import { formatDate } from '@angular/common';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Comissao, ComissaoVendedor, GrupoComissao, TipoComissao,ComissaoProdutoPdf } from "./models/comissao";

@Injectable({
  providedIn: 'root'
})

export class ComissaoService {

  private environmentUrl: string = '';
  private inicio: string;
  private fim: string;

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore + '/comissao';
  }


  getGruposComissao() {
    return this.httpClient.get<GrupoComissao[]>(this.environmentUrl + `/grupocomissao`);
  }

  getTiposComissao() {
    return this.httpClient.get<TipoComissao[]>(this.environmentUrl + `/tipocomissao`);
  }

  getComissoes() {    
    return this.httpClient.get<Comissao[]>(this.environmentUrl);
  }

  getComissao(idUsuario: string, dtInicio: Date, dtFim: Date) {    
    this.inicio = formatDate(dtInicio, 'yyyy-MM-dd', 'en_US');
    this.fim = formatDate(dtFim, 'yyyy-MM-dd', 'en_US');

    return this.httpClient.get<ComissaoVendedor>(this.environmentUrl + `/Usuario/`+idUsuario+`/`+this.inicio+`/`+this.fim);
  }


  delComissao(comissao: Comissao) {
    return this.httpClient.delete(this.environmentUrl + "/" + comissao.idComissaoRegra);
  }

  addComissao(comissao: Comissao) {
    return this.httpClient.post(this.environmentUrl + "/", comissao);
  }

  updComissao(comissao: Comissao) {
    return this.httpClient.put(this.environmentUrl + "/", comissao);
  }

  getComissaoVendedor(dtInicio: Date, dtFim: Date){    
    this.inicio = formatDate(dtInicio, 'yyyy-MM-dd', 'en_US');
    this.fim = formatDate(dtFim, 'yyyy-MM-dd', 'en_US');

    return this.httpClient.get<ComissaoVendedor[]>(this.environmentUrl + `/RelComissaoGroupVendedor/`+this.inicio+`/`+this.fim);
  }

  getComissaoProdutoLista(idUsuario: string, dtInicio: Date, dtFim: Date) {    
    this.inicio = formatDate(dtInicio, 'yyyy-MM-dd', 'en_US');
    this.fim = formatDate(dtFim, 'yyyy-MM-dd', 'en_US');

    return this.httpClient.get<ComissaoProdutoPdf[]>(this.environmentUrl + `/RelComissaoGroupProduto/`+idUsuario+`/`+this.inicio+`/`+this.fim);
  }

}